export const setworkdetails = (p) => {
  return {
    type: "SET_WORKDETAILS",
    payload: p,
  };
};
